<script setup lang="ts">
import { computed } from 'vue';
import { renderRichText } from '@/js/account/shared/lib';
import { classNames } from '@/js/lib/bem';

const props = withDefaults(
  defineProps<{
    content?: string | null
  }>(),
  {
    content: '',
  },
);

const cn = classNames('markdown-content');

const html = computed(() => renderRichText(props.content));
const hasContent = computed(() => html.value !== '');
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -- content is sanitized in renderRichText() -->
  <div
    v-if="hasContent"
    class="base-typography"
    :class="[cn()]"
    v-html="html"
  />
</template>

<style lang="scss" scoped>
.markdown-content {
  font-size: 16px;
  line-height: 1.5;
  color: var(--color-text-secondary);

  :deep(a) {
    color: var(--color-primary);
  }
}
</style>
